import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../service/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthService);
    //console.log("authInterceptor", authService.isTokenValid());
    var token = localStorage.getItem('token');
    const provider = localStorage.getItem('auth_provider');
    if (provider != 'CYBERARK') {
        if (authService.isTokenValid()) {
            token = authService.getNewToken();
            localStorage.setItem('token', token);
        }
    }
    else
    {
        token = authService.startRefreshTimerIfNeeded();
        localStorage.setItem('token', token);
    }
    if(token != null){
    const auth = req.clone({
        setHeaders: {
            Authorization: `Bearer ${token}`
        }
    })
    return next(auth);
}
    return next(req);
};
